import React, { CSSProperties, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip, Button, ButtonProps } from '@routific/hive';

export enum ResolveType {
  WARNING = 'warning',
  DANGER = 'danger',
  SECONDARY = 'secondary',
}

interface Props extends PropsWithChildren {
  style?: CSSProperties;
  disabled?: boolean;
  onResolve: ButtonProps['onClick'];
  type: ResolveType;
  size?: ButtonProps['size'];
}

const ResolveButton: React.FC<Props> = ({ children, disabled, onResolve, type, size, ...restProps }) => {
  const { t } = useTranslation('common');
  const resolveText = children || t('resolveText');

  const getButton = () => {
    return (
      <Button
        warning={type === ResolveType.WARNING}
        danger={type === ResolveType.DANGER}
        underline
        disabled={disabled}
        onClick={onResolve}
        type="link"
        size={size}
        {...restProps}
      >
        {resolveText}
      </Button>
    );
  };
  
  if (disabled) {
    return (
      <Tooltip title={t('noPermission')}>
        {getButton()}
      </Tooltip>
    );
  }

  return getButton();
};

export default ResolveButton;
